<template>
  <div class="position-relative">
    <rx-filter-loading :loading="loading"/>
    <Select2
      v-model="selected"
      @change="onChange()"
      @select="onChange()"
      placeholder="Durum"
      :options="options"
      :settings="{placeholder: 'Seçiniz', multiple: false}"
    />
    <slot></slot>
  </div>
</template>

<script>
import Select2 from 'v-select2-component';
import { getJsonItem } from '../../../../utils/localStorage';

export default {
  name: 'checkBuyBoxStatus',
  components: { Select2 },
  props: ['value'],
  data() {
    return {
      selected: null,
      options: [],
      loading: true,
    };
  },
  methods: {
    onChange() {
      this.$emit('change', { filter: 'checkBuyBoxStatus', data: this.selected });
    },
  },
  beforeMount() {
    this.options = [
      { id: true, text: 'Aktif' },
      { id: false, text: 'Pasif' },
    ];
    const productFilter = getJsonItem('productFilter');
    if (productFilter != null && productFilter.checkBuyBoxStatus != null) {
      this.selected = productFilter.checkBuyBoxStatus;
      this.onChange();
    }
    this.loading = false;
  },
};
</script>
